const MuiCssBaseline = {
  styleOverrides: `
  @import url('https://fonts.googleapis.com/css2?family=Source+Code+Pro&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lato:ital@1&display=swap');
  `,
}

export default MuiCssBaseline
